const DARK_PALETTE_CLASS = 'ion-palette-dark';

const applyPalette = (matches: boolean) => {
  document.documentElement.classList.toggle(DARK_PALETTE_CLASS, matches);
};

// Ionic's dark.class.css only ships colors, it doesn't decide when to apply
// them, so we drive the `.ion-palette-dark` class ourselves from the OS
// preference — keeps dark mode coordinated with our brand palette in
// src/theme/variables.css instead of Ionic's uncoordinated system default.
export function initDarkModePalette(): void {
  const media = window.matchMedia('(prefers-color-scheme: dark)');

  applyPalette(media.matches);
  media.addEventListener('change', (event) => applyPalette(event.matches));
}
